import * as InfoReqStyles from './styles'

import {
  getTagVariantByRegime,
  getTagDatabyNewsCareerStatus,
  getNormalizedRegimeString
} from '../utils'
import BreadcrumbsComponent from 'src/components/BreadcrumbsComponent/BreadcrumbsComponent'
import ColoredTag from 'src/components/ColoredTag'

const ViewCareer = (job: any) => {
  const regimeString = getNormalizedRegimeString(job.job.alt)
  const regimeBadgeTheme = getTagVariantByRegime(job.job.alt)

  const { text: statusText, theme: statusBadgeTheme } =
    getTagDatabyNewsCareerStatus(job.job.status)

  return (
    <>
      <InfoReqStyles.ResponsiveContainer>
        <InfoReqStyles.Container>
          <BreadcrumbsComponent
            crumbs={[
              { label: 'Home', path: '/news/home' },
              { label: 'Vagas', path: '/news/careers' },
              { label: job.job.title }
            ]}
          />

          <InfoReqStyles.JobTitleContainer>
            <InfoReqStyles.TagsContainer>
              <ColoredTag variant={regimeBadgeTheme}>{regimeString}</ColoredTag>
              <ColoredTag variant={statusBadgeTheme}>{statusText}</ColoredTag>
            </InfoReqStyles.TagsContainer>
            <InfoReqStyles.NewsTitle>{job.job.title}</InfoReqStyles.NewsTitle>
          </InfoReqStyles.JobTitleContainer>
          <InfoReqStyles.ContentContainerCareers
            dangerouslySetInnerHTML={{
              __html: job.job.text
            }}
          ></InfoReqStyles.ContentContainerCareers>
          <InfoReqStyles.AplicateContainer>
            <InfoReqStyles.Text>Como aplicar</InfoReqStyles.Text>
            <InfoReqStyles.JobWrapper>
              <InfoReqStyles.TextJob>
                Envie seu currículo para o email:{' '}
              </InfoReqStyles.TextJob>
              <InfoReqStyles.Email>jobs@lsbd.ufc.br</InfoReqStyles.Email>
            </InfoReqStyles.JobWrapper>
            <InfoReqStyles.TextFooter>
              Enviar e-mail com o assunto: [Seleção] {job.job.title} -
              &lt;nome_candidato&gt;
            </InfoReqStyles.TextFooter>
          </InfoReqStyles.AplicateContainer>
        </InfoReqStyles.Container>
      </InfoReqStyles.ResponsiveContainer>
    </>
  )
}

export default ViewCareer
